module.exports = __webpack_public_path__ + "img/clone-icon.d5be7bc3.svg";